










































































































































import Vue from "vue";
import firebase from "firebase/app";
// Required for side effects.
import "firebase/functions";
import "firebase/auth";

// Validation helper.
function atLeast(num: number) {
  return (val: string) =>
    val.trim().length >= num || `Must be at least ${num} characters`;
}

// Validation helper.
function lessThan(num: number) {
  return (val: string) =>
    val.trim().length <= num || `Must be less than ${num} characters`;
}

// Vue component.
export default Vue.extend({
  name: "TheSignUpForm",
  props: {
    source: String,
  },
  data() {
    return {
      valid: false,
      loading: false,
      errorResponse: false,
      errorMessage: "",
      successResponse: false,
      successMessage: "",
      email: "",
      emailRules: [
        (val: string) => !!val || "Email is required",
        (val: string) => /.+@.+\..+/.test(val) || "Email must be valid",
      ],
      password: "",
      passwordRules: [
        (val: string) => !!val || "Password is required",
        atLeast(6),
        lessThan(200),
      ],
      confirmPassword: "",
      displayName: "",
      displayNameRules: [
        (val: string) => !!val || "Display Name is required",
        atLeast(1),
        lessThan(200),
      ],
      jobTitle: "",
      jobTitleRules: [
        (val: string) => !!val || "Job Title is required",
        atLeast(1),
        lessThan(200),
      ],
      department: "",
      departmentRules: [
        (val: string) => !!val || "Department is required",
        atLeast(1),
        lessThan(200),
      ],
      // todo: Improve phone regex format.
      phone: "",
      phoneRules: [
        (val: string) => !!val || "Phone is required",
        atLeast(1),
        lessThan(200),
      ],
    };
  },
  methods: {
    confirmPasswordExits(val: string) {
      return !!val || "Confirm Password is required";
    },
    confirmPasswordMatches(val: string) {
      return val === this.password || "Passwords must match";
    },
    /**
     * Reset the form validation and the field values back to defaults.
     */
    resetForm() {
      (this.$refs.SignUpForm as Vue & {
        resetValidation: () => undefined;
      }).resetValidation();
      this.email = "";
      this.password = "";
      this.confirmPassword = "";
      this.displayName = "";
      this.jobTitle = "";
      this.department = "";
      this.phone = "";
    },
    /**
     * Call the stiltOneCreateAccount cloud function to create a new user in
     * Firebase auth and the RTDB.
     */
    async callCreateAccountCF() {
      // Start the loading indicator.
      this.loading = true;
      // Throw an error if the form data was somehow not valid.
      if (!this.valid) throw "Form data was not valid.";
      // Create a reference to the callable HTTP function.
      const createAccountCF = firebase
        .functions()
        .httpsCallable("stiltOneCreateAccount");
      // Collect data from form fields.
      const formData = {
        email: this.email,
        password: this.password,
        displayName: this.displayName,
        jobTitle: this.jobTitle,
        department: this.department,
        phone: this.phone,
      };
      // Call the cloud functions.
      try {
        await createAccountCF(formData);
        await this.signInUser();
        await this.sendEmailVerification();
        // Reset the form from the reference on success.
        this.resetForm();
      } catch (e) {
        this.errorResponse = true;
        this.errorMessage = e;
      } finally {
        // Stop the loading indicator.
        this.loading = false;
      }
    },
    async signInUser() {
      // Sign the user in.
      await firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password);
    },
    async sendEmailVerification() {
      const currentUser = firebase.auth().currentUser;
      if (currentUser) {
        await currentUser.sendEmailVerification();
        this.successResponse = true;
        this.successMessage = "Success! A verification email has been sent.";
      } else {
        throw "A user is not sign in.";
      }
    },
  },
});
